import { buildHeaderEntity, getBookingBaseAPI } from '../mulesoft.entity';
import { trackEvent } from '../../analytics/aemAnalytics';
import { isValidParam } from '../../utilFuncs/paramUtils';
/**
 * Fetches itinerary data for a given cruise ID and type.
 *
 * @param {string} cruiseID - The ID of the cruise.
 * @param {string} type - The type of itinerary data to fetch (e.g., 'itinerary', 'excursions').
 * @returns The itinerary data.
 * @throws Will throw an error if the request fails.
 */
const getItineraryData = async (cruiseID: string, type: string) => {
  if (!isValidParam(cruiseID) || !isValidParam(type)) return null;
  const API_URL = `${getBookingBaseAPI()}/cruises/${cruiseID}/${type}`;

  const headersEntity = buildHeaderEntity(true, true);

  try {
    const response = await fetch(API_URL, {
      headers: headersEntity.toHeaders() as HeadersInit,
      credentials: 'include',
    });
    return await response.json();
  } catch (error: any) {
    trackEvent('error', {
      error_source: 'Mulesoft',
      error_message: error.message ? error.message : '',
      error_code: error.status ? error.status : '',
    });
    console.error('Error fetching the cruise itinerary:', error);
    throw error;
  }
};

/**
 * Service for fetching itinerary details and excursions.
 */
export const itineraryService = {
  /**
   * Fetches itinerary details for a given cruise ID.
   *
   * @param {string} cruiseID - The ID of the cruise.
   * @returns The itinerary details.
   */
  performItineraryDetails: (cruiseID: string) => {
    return getItineraryData(cruiseID, 'itinerary');
  },

  /**
   * Fetches itinerary excursions for a given cruise ID.
   *
   * @param {string} cruiseID - The ID of the cruise.
   * @returns The itinerary excursions.
   */
  performItineraryExcursions: (cruiseID: string) => {
    return getItineraryData(cruiseID, 'excursions');
  },
};
